"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTimes = require("@fortawesome/free-solid-svg-icons/faTimes");

var _LogInButton = _interopRequireDefault(require("./LogInButton"));

var _LogOutButton = _interopRequireDefault(require("./LogOutButton"));

require("./SliderMenu.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  _setPrototypeOf(subClass.prototype, superClass && superClass.prototype);

  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) {
    return o.__proto__;
  };

  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SliderMenu =
/*#__PURE__*/
function (_React$PureComponent) {
  function SliderMenu() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, SliderMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SliderMenu)).call.apply(_getPrototypeOf2, [this].concat(args))), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {}), _temp));
  }

  _createClass(SliderMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          onClose = _this$props.onClose;
      var userId = this.context.userId;
      return _react.default.createElement("div", {
        className: "crowdaa_slider_menu_container flex-column ".concat(className || 'd-flex')
      }, _react.default.createElement("div", {
        className: "align-self-end m-2"
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faTimes.faTimes,
        size: "1x",
        onClick: onClose,
        className: "ml-1"
      })), _react.default.createElement("nav", null, userId ? _react.default.createElement(_LogOutButton.default, null) : _react.default.createElement(_LogInButton.default, null)));
    }
  }]);

  _inherits(SliderMenu, _React$PureComponent);

  return SliderMenu;
}(_react.default.PureComponent);

exports.default = SliderMenu;

_defineProperty(_defineProperty(_defineProperty(SliderMenu, "propTypes", {
  className: _propTypes.default.string,
  onClose: _propTypes.default.func.isRequired
}), "defaultProps", {
  className: ''
}), "contextTypes", {
  userId: _propTypes.default.string
});